module.exports = __webpack_public_path__ + "img/onboarding-alfred.f639d1d9.svg";